import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AuditEventList = lazy(() => import('~/containers/AuditEventList'));

export default [
  <Route path="/users/:publisherId/audit">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AuditEventList />
    </Suspense>
  </Route>,
];
